export default __webpack_public_path__ + "static/media/AgreementSignature-qZX6x.b494a0e1.ttf";